export default "__VITE_ASSET__ZSDG8PEc__"